import React from 'react';
import rightArrowIcon from '../../assets/images/righArrowIcon.svg';
import { useDispatch } from 'react-redux';
import {
    setLpPdfPlayerpen,
    setLpPdfPlayerResourceId,
    setLpPdfPlayerResourceTitle,
    setLpPdfPlayerResourceType,
    setLpPdfPlayerUrl,
} from '../../features/LpPdfPlayer/LpPdfPlayerSlice';
import { setLPOpen } from '../../features/LP/LPOpenSlice';

interface LPChapterItemProps {
    chapter: any; //LPElement;
    offset: number;
}

const LPChapterItem: React.FC<LPChapterItemProps> = ({ chapter, offset }) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(setLpPdfPlayerpen(true));
        dispatch(setLpPdfPlayerUrl(chapter.resources[0].url));
        dispatch(setLpPdfPlayerResourceType(chapter.resources[0].resourceType));
        dispatch(setLpPdfPlayerResourceId(chapter.resources[0].resource_id));
        dispatch(setLpPdfPlayerResourceTitle(chapter.resources[0].title));
        dispatch(setLPOpen(true));
    };

    return (
        <div className="chapter-item px-6 py-3 hover:bg-[#F7F9FD]">
            <button
                data-testid="lp-chapter-item-button"
                onClick={handleClick}
                className="w-full h-12 bg-transparent rounded text-black flex flex-row justify-between text-md items-center"
            >
                <div className="flex flex-row items-center">
                    <span className={` text-lg `}>
                        {chapter.name.length > 70
                            ? chapter.name.slice(0, 70) + '...'
                            : chapter.name}
                    </span>
                </div>
                <div className="flex flex-row items-center">
                    <span className="text-[#666666] w-1 text-left">
                        {chapter.startpage}
                    </span>
                    <span className="pl-20 pr-4">
                        <img src={rightArrowIcon} alt="right arrow icon" />
                    </span>
                </div>
            </button>
        </div>
    );
};

export default LPChapterItem;
